import Component, { ComponentLoader } from '@bythepixel/component-loader';
import InViewSrc from '@Core/components/inViewSrc';
import InViewSrcset from '@Core/components/inViewSrcset';
import PaginationLinks from '@Core/components/paginationLinks';
import GoogleSearchController from '@Core/controllers/googleSearchController';
import { reloadScripts } from '@Core/utility';

const DEFAULTS = {
  componentsToReload: [InViewSrc, InViewSrcset, PaginationLinks],
};

class BlogController extends Component {
  static selector = '[data-comp-blog-controller]';

  constructor(containerEl, options = DEFAULTS) {
    super(containerEl, options);
    this.componentsToReload = options.componentsToReload || [];

    this.mount();
  }

  attachListeners() {
    window.addEventListener('livewire:pagination-clicked', () => {
      window.scrollTo(0, 0);
    });

    window.addEventListener('livewire:page-updated', () => {
      setTimeout(() => {
        window.Transwest.BlogComponents = reloadScripts(
          document,
          this.componentsToReload,
        );
      }, 100);
    });

    return this;
  }

  removeUrlHash() {
    window.location.hash = '';

    return this;
  }

  mount() {
    // Remove the hash to ensure we're not showing Google Search results
    // on page load
    this.removeUrlHash().attachListeners();
  }
}

window.Transwest.BlogComponents = new ComponentLoader(document, [
  BlogController,
  GoogleSearchController,
]);
